<template>
  <router-view />
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: "Configuration",
  data:{
    previousLanguage:''
  },
  async mounted() {
    this.previousLanguage = this.$store.getters.getLang
    await this.$store.dispatch("setLangNew", "en");
  },
  async beforeDestroy() {
    if(this.previousLanguage){
      await this.$store.dispatch("setLangNew", this.previousLanguage);
    }
  },
  computed:{
    ...mapGetters['getLang']
  }
};
</script>
